module.exports = __webpack_public_path__ + "img/4-off.e6eaae27.png";